export default "__VITE_ASSET__CYukgXQT__"